export class AppConfiguration {
  public companyGuid: string;
  public scanditLicense: string;
  public sharedSecret: string;
}
